// pro.rejouis.fr — coordonnées de livraison des commandes (raison sociale, adresse, téléphone,
// TVA). Le lab les valide (pro-api « coordonnees ») et les fige sur chaque commande : elles
// servent à l'étiquette d'expédition.
import { useState } from 'react';
import { pro } from './lib/api.js';
import { naviguer } from './lib/nav.js';
import { Spinner, Retour } from './components/ui.jsx';

const CHAMPS = [
  ['raisonSociale', 'Raison sociale', 'Nom de la boutique ou de la société', true],
  ['contact', 'Contact', 'Prénom et nom de la personne qui réceptionne', true],
  ['adresse', 'Adresse', 'Numéro et rue', true],
  ['complement', 'Complément d’adresse', 'Bâtiment, étage, code…', false],
  ['cp', 'Code postal', '', true],
  ['ville', 'Ville', '', true],
  ['telephone', 'Téléphone', 'Pour le transporteur', true],
  ['tva', 'N° de TVA intracommunautaire', 'ex. FR12345678901 ou BE0123456789', false],
];

export function resumeAdresse(c) {
  if (!c) return '';
  return [c.raisonSociale, c.adresse, c.complement, `${c.cp} ${c.ville}`, c.pays].filter((x) => x && x.trim()).join(', ');
}

export default function Coordonnees({ initiales, retour = '/', onFait }) {
  const [c, setC] = useState({ pays: 'France', ...(initiales || {}) });
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);
  const maj = (k, v) => setC((x) => ({ ...x, [k]: v }));

  async function enregistrer() {
    setEnCours(true); setErreur(null);
    try {
      await pro('coordonnees', c);
      await onFait();
      naviguer(retour);
    } catch (e) { setErreur(e.message); setEnCours(false); }
  }

  return (
    <div className="anim-pop">
      <Retour />
      <h1 className="t-display" style={{ fontSize: 26, margin: '0 0 6px' }}>Coordonnées de livraison</h1>
      <p className="t-stone" style={{ fontSize: 14.5, lineHeight: 1.6, margin: '0 0 16px' }}>
        L’adresse où nous livrons vos commandes. Elle figure sur l’étiquette du colis et sur la facture.
      </p>
      <div className="card" style={{ padding: 18, display: 'grid', gap: 12 }}>
        {CHAMPS.slice(0, 4).map(([k, label, aide, requis]) => (
          <label key={k}>
            <div className="t-overline" style={{ marginBottom: 4 }}>{label}{requis ? ' *' : ''}</div>
            <input className="field" value={c[k] || ''} placeholder={aide} onChange={(e) => maj(k, e.target.value)}
              autoComplete={{ raisonSociale: 'organization', contact: 'name', adresse: 'address-line1', complement: 'address-line2' }[k]} />
          </label>
        ))}
        <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: 10 }}>
          {CHAMPS.slice(4, 6).map(([k, label, , requis]) => (
            <label key={k}>
              <div className="t-overline" style={{ marginBottom: 4 }}>{label}{requis ? ' *' : ''}</div>
              <input className="field" value={c[k] || ''} onChange={(e) => maj(k, e.target.value)}
                inputMode={k === 'cp' ? 'numeric' : undefined} autoComplete={k === 'cp' ? 'postal-code' : 'address-level2'} />
            </label>
          ))}
        </div>
        <label>
          <div className="t-overline" style={{ marginBottom: 4 }}>Pays *</div>
          <select className="field" value={c.pays} onChange={(e) => maj('pays', e.target.value)}>
            <option>France</option>
            <option>Belgique</option>
          </select>
        </label>
        {CHAMPS.slice(6).map(([k, label, aide, requis]) => (
          <label key={k}>
            <div className="t-overline" style={{ marginBottom: 4 }}>{label}{requis ? ' *' : ''}</div>
            <input className="field" value={c[k] || ''} placeholder={aide} onChange={(e) => maj(k, e.target.value)}
              type={k === 'telephone' ? 'tel' : 'text'} autoComplete={k === 'telephone' ? 'tel' : 'off'} />
          </label>
        ))}
      </div>
      <button className="btn btn-primary btn-block" style={{ marginTop: 18 }} disabled={enCours} onClick={enregistrer}>
        {enCours ? <Spinner size={16} label="Enregistrement…" /> : 'Enregistrer'}
      </button>
      {erreur ? <div style={{ color: 'var(--rouge-sombre)', fontSize: 13, marginTop: 10 }}>{erreur}</div> : null}
    </div>
  );
}
